import React, { useEffect, useState } from 'react';
import { SypacAvatar } from '@sypac/component-library-react';

type SypacAvatarProps = React.ComponentProps<typeof SypacAvatar>;

export interface UserAvatarProps extends Omit<SypacAvatarProps, 'initials'> {
	name?: string;
	photoUrl?: string;
}

const UserAvatar: React.FC<UserAvatarProps> = ({ name, photoUrl, ...rest }) => {
	const [failed, setFailed] = useState<boolean>(false);

	useEffect(() => {
		setFailed(false);
	}, [photoUrl]);

	const showImage = Boolean(photoUrl) && !failed;

	return (
		<SypacAvatar
			key={showImage ? 'image' : 'initials'}
			initials={name}
			{...rest}
		>
			{showImage ? (
				<img
					src={photoUrl}
					alt=""
					onError={() => setFailed(true)}
					className="w-full h-full object-cover rounded-full"
				/>
			) : null}
		</SypacAvatar>
	);
};

export default UserAvatar;
